import { Grid } from "@radix-ui/themes";
import { PortableText } from '@portabletext/react'
import { useEffect, useState } from "react";
import defaultComponents from "../utils/richTextComponent";

const Present = (props) => {

    /**
     * The states (data for the whole page)
     */
    const {service, slides, refresh, isMorning, setIsMorning, currentSlide = 0} = props;
    const [content, setContent] = useState("");
    const [current, setCurrent] = useState(currentSlide);

    /**
     * When currentSlide does update, use it for current slide
     */
    useEffect(() => {
        setCurrent(currentSlide);
    }, [currentSlide])

    /**
     * When receiving a message from the remote page as event: CHANGE_SLIDE, with the index, it updates the current slide
     */
    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data.type === 'CHANGE_SLIDE') {
                setCurrent(event.data.index);
            }
            if (event.data.type === 'REFRESH_DATA') {
                refresh();
                dataUpdate();
                contentUpdate();
                setCurrent(event.data.index);
            }
            if (event.data.type === 'TOGGLE_MORN_EVEN'){
                setIsMorning(event.data.index);
                refresh();
                dataUpdate();
                contentUpdate();
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [slides]);

    /**
     * When any data states update (i.e due to an event from remote), it runs the update functions
     */
    useEffect(() => {
        dataUpdate();
        contentUpdate();
    }, [current, slides, service]);

    /**
     * Handles the actual content component to be displayed on the webpage as a "slide"
     */
    const contentUpdate = () => {
        setContent(
            <PortableText 
                components={defaultComponents}
                value={
                    slides[current]
                        ? slides[current].content
                        : ""
            }/>
        );
    }

    /**
     * Handles the data to display, taking the info from the slide order and inserting the data from the weekly slides
     * MIGHT NOT WANT TO TOUCH THIS UNLESS YOU KNOW WHAT THIS DOES EXACTLY 
     */
    const dataUpdate = () => {
        // Generate dictionary of Data Tag replacements
        let replacements = {};
        Object.keys(service).map(key => replacements["$"+key] = service[key]);

        // Data Tag handler
        console.log(slides);
        if(slides[current])
            slides[current].content.forEach(content => {
                content.children.forEach((child, i) => {
                    if(child.text && child.text.includes("$")){
                        let dataTags = child.text.match(/\$\w+(?:%\d+(?:-\d+)?)?/g);
                        dataTags.forEach(data => {
                            let ctrl = null;
                            if(data.includes("%")){
                                let sections = data.split('%');
                                data = sections[0];
                                ctrl = sections[1];
                                console.log(data, ctrl);
                            }
                            if(Array.isArray(replacements[data])){
                                if(!!ctrl){
                                    let fromTo = [];
                                    if(ctrl.includes("-")){
                                        fromTo = ctrl.split("-");
                                    }else{
                                        fromTo = [ctrl, ctrl];
                                    }
                                    if(replacements[data].length === 1){
                                        replacements[data][0].children[0].text = replacements[data][0]
                                            .children[0].text
                                            .split('\n')
                                            .slice(fromTo[0]-1, fromTo[1])
                                            .join('\n');
                                    }else{
                                        replacements[data] = replacements[data].slice(fromTo[0]-1, fromTo[1]);
                                    }
                                }
                                content.children = replacements[data];
                            }
                            else if(typeof(replacements[data]) === 'string'){
                                child.text = child.text.replaceAll(data, replacements[data]);
                            }
                            else if(replacements[data]?._type === 'file'){
                                child.text = child.text.replaceAll(data, "");
                            }
                        });
                    }
                });
            });
    }

    /**
     * Render function, make sure it only renders page when there actually is something in the slides and service data
     */
    return (
        <>
            {
                slides.length > 0 && Object.keys(service).length > 0
                    ? <Grid columns="auto 1fr auto" gap="3" width="auto">
                        <div className="side"></div>
                        <div className="body">
                            {content}
                        </div>
                        <div className="side"></div>
                    </Grid>
                    : <></>
            }
        </>
    );
}

export default Present;